module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-hocker-06.34730f21.jpeg";